import "@solana/wallet-adapter-react-ui/styles.css"
import "./App.css"
import Home from "./Home"
import ApePage from "./ApePage"
import Layout from "./Layout"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react"
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui"
import { RPC_HOST } from "./useOwnedApes"
import { dnaFromPath } from "./lib"

const display = "\"Chelsea Market\", cursive"

const theme = createTheme({
	palette: {
		mode: "light",
		primary: { main: "#4FA89C", contrastText: "#fff" },
		secondary: { main: "#FF8F7E", dark: "#C4513D", contrastText: "#2B2D42" },
		background: { default: "#FFF8EE", paper: "#fff" },
		text: { primary: "#2B2D42", secondary: "#6B6E85" },
	},
	shape: { borderRadius: 16 },
	typography: {
		fontFamily: "\"Inter\", system-ui, sans-serif",
		h1: { fontFamily: display }, h2: { fontFamily: display }, h3: { fontFamily: display },
		h4: { fontFamily: display }, h5: { fontFamily: display },
		button: { textTransform: "none", fontWeight: 600 },
	},
	components: {
		MuiCard: {
			defaultProps: { elevation: 0 },
			styleOverrides: { root: { border: "1px solid rgba(43,45,66,.08)", boxShadow: "0 10px 30px rgba(43,45,66,.06)" } },
		},
	},
})

// The QR on each ape's tag encodes verify.boredapepastelclub.com/<dna>; netlify.toml serves index.html for every path
const dna = dnaFromPath(window.location.pathname)

// Empty wallet list: Phantom, Solflare, Backpack etc. register themselves via Wallet Standard
const App = () => {
	return (
		<ThemeProvider theme={theme}>
			<ConnectionProvider endpoint={RPC_HOST}>
				<WalletProvider wallets={[]} autoConnect>
					<WalletModalProvider>
						<Layout>
							{dna ? <ApePage dna={dna} /> : <Home />}
						</Layout>
					</WalletModalProvider>
				</WalletProvider>
			</ConnectionProvider>
		</ThemeProvider>
	)
}

export default App
